import { Injectable } from '@angular/core';
import { UtilsService } from '../shared/utils/utils.service';
import { TokenPayload } from '../model/interfaces/tokenPayload';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  private decodedToken!: TokenPayload;

  constructor(
    private readonly _util: UtilsService
  ) {
    this.decodedToken = this._util.getDecodedAccessToken();
  }

  public includeRole(role: string) {
    return this.decodedToken.groups.includes(role)
  }
}
